var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInterv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m10.82 32.74 12.05 9c6.44-2.4 15.15-10.99 17.63-17.63l-9-12.05C30.27 18.22 17 31.5 10.82 32.74Zm12.64-4.92 3.01 3c.82.83 2.14 1.06 3.16.03 1.03-1.03.8-2.34-.02-3.16l-3-3.01 1.96-1.96 3 3a4.88 4.88 0 0 1-.17 6.9 4.88 4.88 0 0 1-6.9.17l-3-3 1.96-1.97Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.76 43.96-4.21-4.21a40.62 40.62 0 0 0 7.95-7.97l4.22 4.21a5.63 5.63 0 0 1-7.96 7.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.22 25.5a12.12 12.12 0 0 1-.08-17.14 12.12 12.12 0 0 1 17.15.08 12.23 12.23 0 0 1 2.81 4.36c.02 4.29-11.23 15.54-15.52 15.52a12.23 12.23 0 0 1-4.36-2.82Z",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterv);
export default __webpack_public_path__ + "static/media/interv.344bc2ac4d6c077059fc2af2d58e027d.svg";
export { ForwardRef as ReactComponent };